import { useAuth } from "../../contexts/AuthContext";
import { createModuleExtensionHost } from "../../modules/extensions/createModuleExtensionHost";

export default createModuleExtensionHost({
  moduleKey: "ledger",
  scriptUrl: "/ledger/extensions/index.js",
  styleUrl: "/ledger/extensions/index.css",
  sdk: { useAuth },
});
